/* Extracted from sections/section-fon-test-results.liquid (was an inline parser-time jQuery block).

   Loaded with `defer` from that section, which renders inside content_for_layout — i.e.
   EARLIER in the document than jquery.min.js in the footer script zone. Deferred scripts
   execute in document order, not load order, so this file runs BEFORE jQuery exists and a
   bare `jQuery(...)` call here throws ReferenceError, killing the whole block.

   DOMContentLoaded fires only after every deferred script has run, so jQuery is guaranteed
   to be defined by then. Do not "simplify" this back to a top-level jQuery() call. */
document.addEventListener('DOMContentLoaded', function () {
jQuery(document).ready(function($){


    $('a[href="#test-results"]').on('click', function (e) {
        e.preventDefault(); // stop default jump if needed
        openTestResults();
    });

    if (window.location.hash === "#onefit-test-results" || window.location.hash === "#onelife-test-results" || window.location.hash === "#test-results") {
        openTestResults()
        
    }

    function openTestResults(){
    $.magnificPopup.open({
            closeOnBgClick: false,
            items: {
                src: '.onefit-test-results' // your popup content div
            },
            type: 'inline',
                callbacks: {
                    open: function() {
                        console.log('Popup body-inline-bottom');
                        $('body').addClass('body-popup-slide-test-result');
                    },
                    close: function() {
                        console.log('Popup closed');
                        $('body').removeClass('body-popup-slide-test-result');
                    }
            },
            mainClass: 'mfp-animate-bottom-test-results',
            
        });


        $(document).on('click','.btn-test-results,.btn-test-results-return',function(){
            var action = $(this).attr('data-action');
            var parent = $(this).parents('.panel-test-results');
            parent.hide();
            parent.siblings('[data-page="'+action+'"]').fadeIn();

            $('.onefit-test-results').attr('data-current-panel',action);
        });

        $(document).on('click', '.test-results-container .result', function() {
            var $this = $(this);
            var beforeAction = $this.attr('data-before-action');
            var action = $this.data('action');
            $('.onefit-test-results').attr('data-current-panel',action);

            var parent = $this.parents('.panel-test-results');
            var panel = parent.siblings('[data-page="'+action+'"]');

            // Fill fields
            panel.find('.lab-logo').attr('src', $this.data('provider-logo') || '');
            panel.find('.cert-intro-text').html($this.data('short-description') || '');

            panel.find('.cert-number-value').html('');
            if ($this.data('cert-number')){
                panel.find('.cert-number-value').text('Cert. No ' + $this.data('cert-number') || '&nbsp;');
            }
            
            panel.find('.cert-description').html($this.data('cert-description') || '');
            panel.find('.prohibited-icon').attr('src', $this.data('cert-item1-icon') || '');
            panel.find('.prohibited-label').text($this.data('cert-item1-label') || '');
            panel.find('.prohibited-status').text($this.data('cert-item1-text') || '');
            panel.find('.last-tested-date').text($this.data('date') || '');
            panel.find('.cert-signature-img').attr('src', $this.data('approved-by-signature') || '');
            panel.find('.cert-by').text($this.data('approved-by') || '');
            panel.find('.cert-by-position').text($this.data('approved-by-position') || '');
            panel.find('.cert-footer').text($this.data('remarks') || '');
            panel.find('.test-download-report').attr('href', $this.data('download-report') || '#');

            panel.find('.cert-provider-img').attr('src', $this.data('provider-logo') || '');

            // Update button attr
            panel.find('.btn-test-results-return').attr('data-action', beforeAction);

            // Switch panels
            parent.hide();
            panel.fadeIn();
        });
    }




});
});
